'use strict';
import packageJson from '../../../../../package.json';

class FooterController {
    constructor() {
        
    }

    $onInit() {
        let date = new Date();
        this.version = `v${packageJson.version}`;
        this.year = date.getFullYear();
    }
}

export default FooterController;


// WEBPACK FOOTER //
// ./src/app/common/layout/footer/footer.controller.js